import React from "react";
import { Button, ArrowLeftIcon, ArrowRightIcon } from "convertupleads-theme";
import PreviewAndEditor from "../../../../../common/PreviewAndEditor";

const DefaultBtnWithIcons = () => {
  return (
    <>
      <PreviewAndEditor
        height={"100px"}
        language="js"
        title={"Contained button with start and end icon"}
        value={
          "<Button startIcon={<ArrowLeftIcon />} endIcon={<ArrowRightIcon />}>\n" +
          "            Label\n" +
          "          </Button>"
        }
      >
        <Button
          startIcon={<ArrowLeftIcon />}
          endIcon={<ArrowRightIcon />}
        >
          Label
        </Button>
      </PreviewAndEditor>
    </>
  );
};

export default DefaultBtnWithIcons;
